var _defs, _line, _line2, _line3, _line4, _line5, _line6, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#0baeff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-1, 0, 0, 1, -82.03, 0)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: -101.28,
    x2: -122.37,
    y1: 46.39,
    y2: 19.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0, -1, -1, 0, 137.46, -102.8)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: -137.98,
    x2: -126.37,
    y1: 85.19,
    y2: 102.84
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.5,
    x2: 32.5,
    y1: 50.5,
    y2: 51.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.5,
    x2: 26.5,
    y1: 48.5,
    y2: 49.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.5,
    x2: 38.5,
    y1: 48.5,
    y2: 49.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.5,
    x2: 38.5,
    y1: 54.5,
    y2: 55.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.5,
    x2: 26.5,
    y1: 54.5,
    y2: 55.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.5,
    x2: 32.5,
    y1: 56.5,
    y2: 57.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.66,9.9a17.49,17.49,0,0,1,15.47,9.32A13.75,13.75,0,1,1,46,44.84l-22.39.06a17.5,17.5,0,0,1,0-35Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.05,
    cy: 31.09,
    r: 13.75,
    transform: "translate(3.72 67.08) rotate(-74.39)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.e6d1c28a2a1cdb69ba03045eca9a32d9.svg";
export { ForwardRef as ReactComponent };